const log = (...args) => window.SAS_DEBUG && console.log("[SAS]", ...args);

document.addEventListener("DOMContentLoaded", () => {
    const dataScript = document.getElementById("sas-selling-options-type-data");
    if (!dataScript) return;

    let data = null;

    try {
        data = JSON.parse(dataScript.textContent);
    } catch (e) {
        log("Error parsing selling options data:", e);
        return;
    }

    function normalize(type) {
        if (!type) return null;
        type = type.toLowerCase().trim();
        if (type === "call_for_price" || type.includes("call")) return "call_for_price";
        if (type === "custom_button" || type.includes("custom")) return "custom_button";
        if (type === "inquire_button" || type.includes("inquire")) return "inquire_button";
        return null;
    }

    const globalType = normalize(data.globalType);

    const buttons = {
        call_for_price: document.querySelector(".call_btn"),
        custom_button:  document.querySelector(".custom_btn"),
        inquire_button: document.querySelector(".btn-inquired")
    };

    function hideAll() {
        Object.values(buttons).forEach(btn => {
            if (btn) btn.style.display = "none";
        });
    }

    function show(type) {
        hideAll();
        const btn = buttons[type];
        if (btn) btn.style.display = "block";
    }

    function getTypeForVariantId(variantId) {
        const variant = data.variants.find(v => v.id === variantId);
        return normalize(variant?.selling_options) || globalType;
    }

    function applyInitialType() {
        const variantInput = document.querySelector(`form[id*="${data.productId}"] input[name="id"], input[name="id"]`);
        const variantId = variantInput ? parseInt(variantInput.value) : data.variants[0]?.id;
        if (variantId) show(getTypeForVariantId(variantId));
    }

    applyInitialType();

    document.addEventListener("on:variant:change", (event) => {
        const variant = event.detail?.variant;
        if (!variant) return;
        show(getTypeForVariantId(variant.id));
    });
});
